<template>
  <div class="wrapper p-0 p-md-3">
    <!-- Main carousel -->
    <agile class="main" ref="main" :options="main_options" :as-nav-for="main_asNavFor">
      <div v-for="(item, index) in media" :key="index" class="slide" :class="`slide--${index}`">
        <img v-if="item.type == 'image'" :src="item.url" />
        <GalleryYoutubeEmbed v-else-if="item.type == 'youtube'" :url="item.url" />
      </div>
    </agile>
    <!-- Nav carousel (thumbnails) -->
    <agile
      class="thumbnails"
      ref="thumbnails"
      :options="thumbnails_options"
      :as-nav-for="thumbnails_asNavFor"
    >
      <div
        v-for="(item, index) in media"
        :key="index"
        class="slide slide--thumbnail"
        :class="`slide--${index}`"
        @click="$refs.thumbnails.goTo(index)"
      >
        <img :src="item.type === 'youtube' ? getYoutubeThumbnail(item.url).hq : item.url" />
      </div>
    </agile>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile'
import { getYoutubeThumbnail } from '@/utilities.helpers.js'
import GalleryYoutubeEmbed from '@/Components/GalleryYoutubeEmbed'

export default {
  name: 'GalleryCarousel',
  components: { agile: VueAgile, GalleryYoutubeEmbed },
  props: {
    media: {
      type: Array,
      required: true,
      validator(value) {
        // Validate that every item on the array ('media') has the required keys
        return value.every(item =>
          Object.keys(item).every(key => ['id', 'type', 'url'].includes(key)),
        )
      },
    },
  },
  data() {
    return {
      main_asNavFor: [],
      thumbnails_asNavFor: [],
      main_options: { dots: false, fade: true, navButtons: false },
      thumbnails_options: {
        navButtons: false,
        dots: false,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 5,
            },
          },

          {
            breakpoint: 1000,
            // settings: {
            //   navButtons: true,
            // },
          },
        ],
      },
    }
  },
  mounted() {
    this.main_asNavFor.push(this.$refs.thumbnails)
    this.thumbnails_asNavFor.push(this.$refs.main)
  },
  methods: {
    getYoutubeThumbnail,
  },
}
</script>

<style lang="sass" scoped>
// Global
.wrapper
	font-family: sans-serif
	font-weight: 300
	margin: 0 auto
	max-width: 900px

.main
	margin-bottom: 30px

.thumbnails
	margin: 0 -5px
	width: calc(100% + 10px)

// Basic VueAgile styles
.agile
	&__nav-button
		background: transparent
		border: none
		color: #ccc
		cursor: pointer
		font-size: 24px
		transition-duration: .3s

		.thumbnails &
			position: absolute
			top: 50%
			transform: translateY(-50%)

			&--prev
				left: -45px

			&--next
				right: -45px

		&:hover
			color: #888

	&__dot
		margin: 0 10px

		button
			background-color: #eee
			border: none
			border-radius: 50%
			cursor: pointer
			display: block
			height: 10px
			font-size: 0
			line-height: 0
			margin: 0
			padding: 0
			transition-duration: .3s
			width: 10px

		&--current,
		&:hover
			button
				background-color: #888

// Slides styles
.slide
	align-items: center
	box-sizing: border-box
	color: #fff
	display: flex
	height: 100%
	justify-content: center

	&--thumbnail
		cursor: pointer
		height: 100px
		padding: 0 5px
		transition: opacity .3s

		&:hover
			opacity: .75

	img
		height: 100%
		object-fit: cover
		object-position: center
		width: 100%

	div.plyr
		height: 100%
		width: 100%
</style>
